export default __webpack_public_path__ + "static/media/635.dae64460.jpg";